<template>
	<el-row>
		<el-col :span="24">
			<div class="base-form header">
				<h2 v-if="viewType == ViewType.Viewing || viewType == ViewType.Editing">
					Карточка контрагента 
					<span>{{ `${originCounterparty?.lastname ?? ''} ${ originCounterparty?.firstname ? `${originCounterparty?.firstname.substring(0,1)}.` : ''}` }}</span>
				</h2>
				<h2 v-else>
					Новый контрагент
					<span>{{ `${ruleForm.lastname ?? ''} ${ ruleForm.firstname ? `${ruleForm.firstname.substring(0,1)}.` : ''}` }}</span>
				</h2>

				<el-radio-group v-if="viewType == ViewType.Viewing || viewType == ViewType.Editing" v-model="viewType" @change="onViewTypeChange" size="small">
					<el-radio-button label="Просмотр" :value="ViewType.Viewing" />
					<el-radio-button label="Редактировать" :value="ViewType.Editing" />
				</el-radio-group>
			</div>
		</el-col>		
	</el-row>
	<el-row>
		<el-col :span="24">
		
			<div v-if="viewType == ViewType.Viewing" class="base-form form" style="width: 100%; max-width: 100%;">				
				<el-space alignment="start" wrap :fill-ratio="49" :size="20" direction="horizontal" v-if="originCounterparty?.id">
					<!-- Base info of a counterparty -->
					<el-card class="box-card" style="width: 640px;">
						<template #header>
							<div class="card-header">
								<el-row align="middle">
									<el-col :span="2">
										<el-icon size="22"><Postcard /></el-icon>
									</el-col>
									<el-col :span="22">
										{{ originCounterparty.lastname }} {{ originCounterparty.firstname }} {{ originCounterparty.middlename }}
										<div>
											<el-text size="small" type="info">
												зарегистрирован {{ dateFormatter(originCounterparty.date, false, true) }}
											</el-text>
										</div>
									</el-col>
								</el-row>						
							</div>
						</template>

						<el-row align="middle" v-if="originCounterparty.types">
							<el-col :span="1">
								<el-icon><Medal /></el-icon>
							</el-col>
							<el-col :span="23">			
								<div>
									<div v-for="t in originCounterparty.types" :key="t" style="display: inline-block; margin-right: .3rem">
										<counterparty-type-component :type="t" />
									</div>
								</div>
								<el-text type="info" size="small">
									&nbsp;значки контрагента
								</el-text>
							</el-col>
						</el-row>

						<el-row align="middle" style="margin: .68rem 0;">
							<el-col :span="1">
								<el-icon><Phone /></el-icon>
							</el-col>
							<el-col :span="23">			
								<div>
									<el-text size="large">
										{{ originCounterparty.phone }}
									</el-text>
								</div>
								<el-text type="info" size="small">
									&nbsp;номер телефона
								</el-text>
							</el-col>
						</el-row>

						<el-row align="middle" v-if="originCounterparty.manager?.id" :gutter="5" style="margin: .68rem 0;">
							<el-col :span="1">
								<el-icon><User /></el-icon>
							</el-col>
							<el-col :span="23">
								<div>
									<el-text size="large">
										{{ `${originCounterparty.manager.firstname}` }} {{ originCounterparty.manager.firstname ? `${originCounterparty.manager.firstname.substring(0,1)}.` : '' }}
									</el-text>
								</div>
								<el-text type="info" size="small">
									&nbsp;менеджер
								</el-text>
							</el-col>
						</el-row>

						<el-row v-if="originCounterparty.birthdate" align="middle" style="margin: .68rem 0;">
							<el-col :span="1">
								<el-icon size="16"><Calendar /></el-icon>
							</el-col>
							<el-col :span="23">							
								<div>
									<el-text size="large">
										{{ dateFormatter(originCounterparty.birthdate, false, true) }}
									</el-text>
								</div>
								<el-text type="info" size="small">
									&nbsp;дата рождения
								</el-text>
							</el-col>
						</el-row>
						
						<el-row v-else align="middle" style="margin: .68rem 0;">
							<el-col :span="1">
								<el-icon size="16"><Calendar /></el-icon>
							</el-col>
							<el-col :span="23">
								<el-text type="info">
									дата рождения не указана
								</el-text>
							</el-col>
						</el-row>

						<el-row align="middle" style="margin: .68rem 0;">
							<el-col :span="1">
								<el-icon><Message /></el-icon>
							</el-col>
							<el-col :span="23">							
								<div v-if="originCounterparty.email">
									<el-link type="primary" :href="`mailto:${originCounterparty.email}`" style="font-size: var(--el-font-size-medium)">
										{{ originCounterparty.email }}
									</el-link>
								</div>
								<el-text v-else type="info">
									почтовый адрес не указан
								</el-text>
							</el-col>
						</el-row>

						<el-row align="middle" v-if="originCounterparty.isMale != null" style="margin: .68rem 0;">
							<el-col :span="1">
								<el-icon><Male /></el-icon>
							</el-col>
							<el-col :span="23">							
								<el-text size="large">
									{{ originCounterparty.isMale === true ? 'мужчина' : (originCounterparty.isMale === false ? 'женщина' : '') }}
								</el-text>
							</el-col>
						</el-row>

						<template #footer v-if="originCounterparty.notes">
							<el-row align="middle">
								<el-col :span="1">
									<el-icon><CollectionTag /></el-icon>
								</el-col>
								<el-col :span="23">
									<el-text>
										{{ originCounterparty.notes }}
									</el-text>
								</el-col>
							</el-row>
						</template>
					</el-card>

					<!-- Legal entity info of related counterparty (if exists)  -->
					<el-card class="box-card" style="width: 640px;" v-if="originCounterparty.legalEntity?.id">
						<template #header>
							<div class="card-header">
								<el-row align="middle">
									<el-col :span="2">
										<el-icon size="22"><SuitcaseLine /></el-icon>
									</el-col>
									<el-col :span="22">
										{{ originCounterparty.legalEntity.name }}
										<div>
											<el-text size="small" type="info">
												зарегистрирован {{ dateFormatter(originCounterparty.legalEntity.date, false, true) }}
											</el-text>
										</div>
									</el-col>
								</el-row>
							</div>
						</template>

						<el-row align="middle" style="margin: .68rem 0;">
							<el-col :span="1">
								<el-icon><OfficeBuilding /></el-icon>
							</el-col>
							<el-col :span="23">
								<div>
									<el-text size="large">
										{{ originCounterparty.legalEntity.taxNo }} 
										{{ originCounterparty.legalEntity.kppNo ? `/ ${originCounterparty.legalEntity.kppNo}` : '' }}
									</el-text>
								</div>
								<el-text type="info" size="small">
									&nbsp;ИНН / КПП
								</el-text>
							</el-col>
						</el-row>

						<el-row align="middle" style="margin: .68rem 0;">
							<el-col :span="1">
								<el-icon><Location /></el-icon>
							</el-col>
							<el-col :span="23">
								<div>
									<el-text size="large">
										{{ originCounterparty.legalEntity.legalAddress }}
									</el-text>
								</div>
								<el-text type="info" size="small">
									&nbsp;юридический адрес
								</el-text>
							</el-col>
						</el-row>

						<el-row align="middle" style="margin: .68rem 0;">
							<el-col :span="1">
								<el-icon><LocationInformation /></el-icon>
							</el-col>
							<el-col :span="23">
								<div>
									<el-text size="large">
										{{ originCounterparty.legalEntity.actualAddress }}
									</el-text>
								</div>
								<el-text type="info" size="small">
									&nbsp;фактический адрес
								</el-text>
							</el-col>
						</el-row>

						<el-row align="middle" v-if="originCounterparty.legalEntity?.siteUrl" style="margin: .68rem 0;">
							<el-col :span="1">
								<el-icon><Link /></el-icon>
							</el-col>
							<el-col :span="23">
								<el-text size="large">
									{{ originCounterparty.legalEntity.siteUrl }}
								</el-text>
							</el-col>
						</el-row>

						<el-row align="middle" v-if="originCounterparty.legalEntity?.email" style="margin: .68rem 0;">
							<el-col :span="1">
								<el-icon><Message /></el-icon>
							</el-col>
							<el-col :span="23">
								<el-text size="large">
									<el-link type="primary" :href="`mailto:${originCounterparty.legalEntity.email}`" style="font-size: var(--el-font-size-medium)">
										{{ originCounterparty.legalEntity.email }}
									</el-link>
								</el-text>
							</el-col>
						</el-row>
					</el-card>

					<!-- Vehicles list of counterparty -->
					<el-card style="min-width: 640px">
						<template #header>
							<div class="card-header">
								<el-row align="middle">
									<el-col :span="2">
										<el-icon size="22"><Van/></el-icon>
									</el-col>
									<el-col :span="22">
										Автомобили
									</el-col>
								</el-row>						
							</div>
						</template>
						<el-table
							:data="originCounterparty?.vehicles">			
							<template #empty>
								<el-text type="info">У контрагента нет автомобилей ☹️</el-text>
							</template>	
							<el-table-column label="Автомобиль" prop="model">
								<template #default="scope">
									{{ scope.row.model.manufacturer.name }}
									{{ scope.row.model.name }}
								</template>
							</el-table-column>							
							<el-table-column prop="vin" label="VIN" />
							<el-table-column prop="govermentalNumber" label="Гос. номер" />
						</el-table>
					</el-card>
				</el-space>

				<el-space fill style="width: calc(100% - 2rem); margin-top: 20px;" v-if="originCounterparty?.id">
					<el-card v-loading="isOrdersLoadPending">
						<template #header>
							<div class="card-header">
								<el-row align="middle">
									<el-col>
										<el-icon size="22"><Coin/></el-icon>
										&nbsp;Заказ-наряды
									</el-col>
								</el-row>						
							</div>
						</template>
							<el-table
								row-key="id"
								class="custom-loading-svg"
								element-loading-svg-view-box="-10, -10, 50, 50" 
								:data="ordersList"
								:element-loading-svg="ordersLoadPendingSvg"
								:default-sort="{ prop: ordersSortColumn, order: ordersSortDir }"
								:summary-method="calculateOrdersTotalCostSum">
								<template #empty>
									<el-text type="info">Контрагент еще не посетил нас ☹️</el-text>
								</template>
								<el-table-column prop="id" label="№" column-key="id">
									<template #default="scope">
										{{ scope.row.number }}
										<div>
											<order-status-component :status="scope.row.statusId" />
										</div>
									</template>
								</el-table-column>
								<el-table-column sortable column-key="date" prop="date" label="Дата">
									<template #default="scope">
										<div>
											принят {{ dateFormatter(scope.row.date, true) }}
										</div>
										<div v-if="scope.row.closingDate">
											завершен {{ dateFormatter(scope.row.closingDate, false) }}
										</div>
									</template>
								</el-table-column>
								<el-table-column label="Менеджер">
									<template #default="scope">
										<el-link type="primary">{{ `${scope.row.manager.lastname} ${scope.row.manager.firstname?.substring(0,1)}.` }}</el-link>
									</template>
								</el-table-column>
								<el-table-column prop="vehicle" label="Автомобиль">
									<template #default="scope">
										{{ `${scope.row.vehicle?.model?.manufacturer?.name} ${scope.row.vehicle?.model?.name}`}}
										<div>
											<el-text size="small">
												{{ scope.row.vehicle.vin }}
											</el-text>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="customer" label="Работа">
									<template #default="scope">
										<el-tag style="margin-right: .3rem;" type="info" size="small" v-for="j in scope.row.jobs" :key="j.id">
											{{ j.serviceJob.component.name }}							
										</el-tag>
									</template>
								</el-table-column>
								<el-table-column prop="customer" label="Исполнитель" column-key="customerId">
									<template #default="scope">
										<text v-for="j in scope.row.jobs" :key="j.id">							
											<el-tag style="margin-right: .3rem;" type="info" size="small" v-for="a in j.assignees" :key="a.id">
												{{ a.employee?.lastname + ' ' + a.employee.firstname?.substring(0,1) + '.' }}
											</el-tag>
										</text>
									</template>
								</el-table-column>
								<el-table-column :formatter="tableOrderTotalCostFormatter" label="Итого (руб.)" column-key="orderTotal" />
							</el-table>
					</el-card>
				</el-space>
			</div>

			<div v-if="viewType != ViewType.Viewing" class="base-form">
				<el-form :model="ruleForm" ref="counterpartyForm" status-icon :rules="rules" v-loading="isAsyncOperationPending">
					<el-form-item label="Тип контрагента" label-position="top">
						<el-select
							multiple
							v-model="ruleForm.counterpartyTypes"
							placeholder="Выберите из списка"
						>
							<template #label="scope">
								<counterparty-type-component :type="scope.value" />
							</template>
							<el-option
								v-for="item in availCounterpartyTypes"
								:key="item"
								:value="item">
								<counterparty-type-component :type="item" />
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="Фамилия" label-position="top" prop="lastname">
						<el-input v-model="ruleForm.lastname" />
					</el-form-item>

					<el-form-item label="Имя" label-position="top" prop="firstname">
						<el-input v-model="ruleForm.firstname" />
					</el-form-item>

					<el-form-item label="Отчество" label-position="top" prop="middlename">
						<el-input v-model="ruleForm.middlename" />
					</el-form-item>

					<el-form-item label="Телефон" label-position="top">
						<input-phone-component v-model="ruleForm.phone" />
					</el-form-item>

					<el-form-item label="Почтовый адрес (e-mail)" label-position="top">
						<el-input v-model="ruleForm.email" />
					</el-form-item>

					<el-form-item label="Дата рождения" label-position="top">
						<el-date-picker
							v-model="ruleForm.birthdate"
							type="date"
							format="DD.MM.YYYY"
							placeholder="Выберите дату рождения"
						/>
					</el-form-item>

					<el-form-item label="Пол" label-position="top">
						<el-radio-group v-model="ruleForm.isMale">
							<el-radio-button :value="true">Мужчина</el-radio-button>
							<el-radio-button :value="false">Женщина</el-radio-button>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="Менеджер" label-position="top">
						<select-manager-component
							v-model="ruleForm.managerId"
							:managers="managers"
						/>
					</el-form-item>

					<el-form-item label-position="top">
						<el-radio-group v-model="ruleForm.isLegal">
							<el-radio-button :value="false">Физическое лицо</el-radio-button>
							<el-radio-button :value="true">Юридическое лицо (ООО, ИП, ПАО, АО)</el-radio-button>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="Юридическое лицо" label-position="top" prop="legalEntity">		
						<div style="width: 95%;">
							<catalog-picker-component
								ref="legalEntityComponent"
								v-model="ruleForm.legalEntity"
								:disabled="!ruleForm.isLegal"
								placeholder="Поиск юр. лиц по названию компании, имени или фамилии ИП, ИНН" 
								search-url="/api/legalentities"
								:catalog-tab="vehicleCatalogTab">
								<template #label>
									{{ ruleForm.legalEntity?.name }}
								</template>
								<template #default="scope">
									<div>
										<span style="float: left">{{ scope.name }}</span>
										<span style="float: right; color: var(--el-text-color-secondary)">
											{{ `${scope.taxNo ? `ИНН ${scope.taxNo}` : ''}` }}
										</span>
									</div>
								</template>
							</catalog-picker-component>
						</div>					
					</el-form-item>

					<el-form-item label="Заметки" label-position="top">
						<el-input							
							v-model="ruleForm.notes"
							maxlength="5000"
							show-word-limit
							type="textarea"
							placeholder="Заметки (опционально)"
						/>
					</el-form-item>	
					
					<el-form-item>
						<el-button type="primary" @click="onSubmitFormClick">
							{{ viewType == ViewType.Creating ? 'Создать' : 'Сохранить' }}
						</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-col>
	</el-row>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import CatalogPickerComponent from '@/components/CatalogPickerComponent.vue';
import { Postcard, Phone, Calendar, Message, EditPen, Collection, OfficeBuilding, Coin, Van, Male, CollectionTag, Location, LocationInformation, SuitcaseLine, User, Medal, Link } from '@element-plus/icons-vue';
import { ElButton, ElTable, ElLink, FormInstance, ElNotification } from 'element-plus';
import { h, reactive } from 'vue';
import { date as dateFormatter } from '@/helpers/formatters';
import axiosHelper from '@/helpers/axiosHelper';
import store from '@/store';
import EventHelper from '@/helpers/eventsHelper';
import CounterpartyModel from '@/models/CounterpartyModel';
import EmployeeModel from '@/models/EmployeeModel';
import EmployeesApiHelper from '@/helpers/api/EmployeesApiHelper';
import LegalEntityModel from '@/models/LegalEntityModel';
import ViewType from '@/models/enums/ViewType';
import OrderModel from '@/models/OrderModel';
import TabsDictionary from '@/variables/tabs';
import SelectManagerComponent from '@/components/SelectManagerComponent.vue';
import CounterpartyTypeComponent from '@/components/CounterpartyTypeComponent.vue';
import CounterpartyType from '@/models/enums/CounterpartyType';
import InputPhoneComponent from '@/components/InputPhoneComponent.vue';

interface ICounterpartyForm {
	id: number,
	date?: Date,
	lastname: string,
	firstname: string,
	middlename: string | null,
	phone: string | null,
	email: string | null,
	isMale: boolean | null,
	isLegal: boolean,
	birthdate: Date | null,	
	notes: string | null,
	managerId: number | null,
	legalEntity: LegalEntityModel | null
	counterpartyTypes: Array<number> | null
}

@Options({
	components: {
		ElButton, ElTable, ElLink, CatalogPickerComponent,
		Postcard, Phone, Calendar, Message, Collection, OfficeBuilding, Coin, Van, EditPen, Male, CollectionTag, Location, LocationInformation, SuitcaseLine, User, Medal, Link,
		SelectManagerComponent, CounterpartyTypeComponent, InputPhoneComponent
	},
	props: {
		params: Array
	}
})
export default class CounterpartyView extends Vue {
	/** params */
	params!: Array<any>;
	
	/** constants */
	ViewType = ViewType;
	viewType: ViewType = this.ViewType.Viewing;
	originCounterparty: CounterpartyModel | null = null;
	availCounterpartyTypes = [ 
		CounterpartyType.Consumer, 
		CounterpartyType.Contractor, 
		CounterpartyType.Supplier
	];
	reloadTableEvent = 'counterpartiesListUpdate';
	ordersLoadPendingSvg = `<path class="path" d="M 30 15 L 28 17 M 25.61 25.61 A 15 15, 0, 0, 1, 15 30 A 15 15, 0, 1, 1, 27.99 7.5 L 15 15" style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>`;
	ordersSortColumn = 'id';
	ordersSortDir = 'asc';

	vehicleCatalogTab = TabsDictionary.vehicleAdd;

	managers: Array<EmployeeModel> = [];

	/** view-models */
	isOrdersLoadPending = false;
	isAsyncOperationPending = false;
	ordersList = new Array<OrderModel>();

	ruleForm: ICounterpartyForm = reactive({
		id: 0,
		date: new Date(),
		lastname: '',
		firstname: '',
		middlename: null,
		phone: '',
		email: null,
		isMale: true,	
		isLegal: false,
		birthdate: null,
		managerId: 0,
		legalEntity: null,
		notes: null,
		counterpartyTypes: []
	});

	rules = reactive({
		lastname: [			
			{ required: true, message: 'Фамилия не может быть пустой'},
			{ min: 1, max: 255, message: 'Фамилия не может быть короче 1 и длинее 255 символов'}			
		],
		firstname: [			
			{ required: true, message: 'Имя не может быть пустым'},
			{ min: 1, max: 255, message: 'Имя не может быть короче 1 и длинее 255 символов'}
		],
		middlename: [						
			{ min: 1, max: 255, message: 'Отчество не может быть короче 1 и длинее 255 символов'}
		],
		legalEntity: [
			{ validator: (a: any, b: any, c: any) => this.legalEntityValidator(a,b,c), trigger: 'blur' }
		]
	});

	mounted() {
		this.isAsyncOperationPending = true;		
		this.initViewAsync()
			.then(() => this.isAsyncOperationPending = false)
			.catch(() => this.isAsyncOperationPending = false);
	}

	/**
	 * init form with counterparty's data from incoming params
	 */
	async initViewAsync() {
		if (!this.params?.length ||
			this.params.length != 2) {
			this.params = [null, ViewType.Creating];
		}

		this.viewType = this.params[1] as ViewType;

		if (this.viewType == ViewType.Editing ||
			this.viewType == ViewType.Viewing) {

			const counterpartyId = this.params[0] as number;

			if (!counterpartyId) {
				ElNotification({
					message: 'Ошибка загрузки карточки контрагента',
					type: 'error',
				});		
				return;
			}

			this.originCounterparty = await this.getCounterpartyAsync(counterpartyId);

			if (!this.originCounterparty?.id) {		
				ElNotification({
					message: 'Ошибка загрузки карточки контрагента',
					type: 'error',
				});		
				return;
			}

			this.ruleForm.id = this.originCounterparty.id;
			this.ruleForm.lastname = this.originCounterparty.lastname as any;
			this.ruleForm.firstname = this.originCounterparty.firstname as any;
			this.ruleForm.middlename = this.originCounterparty.middlename as any;
			this.ruleForm.phone = this.originCounterparty.phone;
			this.ruleForm.email = this.originCounterparty.email;
			this.ruleForm.isMale = this.originCounterparty.isMale;
			this.ruleForm.birthdate = this.originCounterparty.birthdate;		
			this.ruleForm.notes = this.originCounterparty.notes;
			this.ruleForm.isLegal = !!this.originCounterparty.legalEntity?.id;
			this.ruleForm.legalEntity = this.originCounterparty.legalEntity?.id ? this.originCounterparty.legalEntity : null;
			this.ruleForm.managerId = this.originCounterparty.manager?.id ?? null;
			this.ruleForm.counterpartyTypes = this.originCounterparty?.types?.length ? this.originCounterparty.types.map(_ => _ as number) : [];
			this.fetchOrdersAsync();
		}
		
		this.fetchManagersAsync();
	}

	/** fires when user toggles view type: Card | Editing  */
	onViewTypeChange(viewType: ViewType) {
		if (viewType == ViewType.Editing) {
			if (this.originCounterparty?.legalEntity?.id) {
				const legalEntityPickerComponent = this.$refs.legalEntityComponent as any;
				if (legalEntityPickerComponent) {
					legalEntityPickerComponent.set(new LegalEntityModel(this.originCounterparty.legalEntity));
				}
			}
		}
	}

	onSubmitFormClick() {
		const form = this.$refs.counterpartyForm as FormInstance;
		form.validate(async (valid) => {
			if (!valid) {
				return;
			}
			// eslint-disable-next-line 
			let asyncOperationHandler: (arg0: ICounterpartyForm) => Promise<boolean | null>;

			const creatingCounterparty = this.viewType == ViewType.Creating
			if (creatingCounterparty) {
				asyncOperationHandler = this.createCounterpartyAsync;
			} else {
				asyncOperationHandler = this.updateCounterpartyAsync;
			}

			this.isAsyncOperationPending = true;							
			const isSuccess = await asyncOperationHandler(this.ruleForm);
			if (isSuccess === true) {
				ElNotification({
					message: `Контрагент успешно ${creatingCounterparty ? 'создан' : 'изменен'}`,
					type: 'success',
				});
				this.closeCurrentTab();
				EventHelper.dispatchEvent(this.reloadTableEvent);
			} else if (isSuccess === false) {
				ElNotification({							
					message: `Ошибка ${creatingCounterparty ? 'создания нового' : 'изменения'} контрагента`,					
					type: 'error',
				});
			} else {
				ElNotification({
					message: `Ошибка соединения, не удалось ${creatingCounterparty ? 'создать нового' : 'изменить'} контрагента`,
					type: 'error',
				});
			}
			this.isAsyncOperationPending = false;
		});
	}

	closeCurrentTab() {		
		store.commit('removeTab', store.getters.tab);
	}

	formatPhoneCountryCode(phoneNumber: string | null) {
		if (!phoneNumber) {
			return null;
		}
		
		if (phoneNumber.startsWith('+')) {
			return phoneNumber.substring(0, 2);
		}

		return phoneNumber.substring(0, 1);
	}

	formatPhoneNumber(phoneNumber: string | null) {
		if (!phoneNumber) {
			return null;
		}

		if (phoneNumber.startsWith('+')) {
			return phoneNumber.substring(2);
		}

		return phoneNumber.substring(1);
	}
	
	async fetchManagersAsync() {
		this.managers = [
			new EmployeeModel({id: 0})
		];
		const existingManagers = await new EmployeesApiHelper().getManagersAsync(store.getters.jwt);
		existingManagers.forEach(m =>
			this.managers.push(m)
		);
	}

	async createCounterpartyAsync(requestForm: ICounterpartyForm) {
		try {
			const request = this.mapCounterpartyRequest(requestForm);
			const addCounterpartyHttpClient = axiosHelper.createInstance(store.getters.jwt);
			await addCounterpartyHttpClient.post('/api/counterparties', request);
			return true;
		} catch(e: any) {
			if (e?.status === 409) {				
				return false;
			}

			console.error('Error creating counterparty', e);
			return null;
		}
	}

	async updateCounterpartyAsync(requestForm: ICounterpartyForm) {	
		try {			
			const request = this.mapCounterpartyRequest(requestForm);
			const updateCounterpartyHttpClient = axiosHelper.createInstance(store.getters.jwt);
			await updateCounterpartyHttpClient.put('/api/counterparties', request);
			return true;
		} catch(e: any) {
			if (e?.status === 409) {				
				return false;
			}
			console.error('Error updating counterparty', e);
			return null;
		}		
	}

	async getCounterpartyAsync(counterpartyId: number) : Promise<CounterpartyModel | null> {
		try {
			const getCounterpartyHttpClient = axiosHelper.createInstance(store.getters.jwt);
			const counterpartyResponse = await getCounterpartyHttpClient.get(`/api/counterparties/${counterpartyId}`);
			const counterparty = new CounterpartyModel(counterpartyResponse.data);
			return counterparty;
		} catch (e: any) {
			if (e?.status === 404) {		
				ElNotification({
					message: 'Ошибка - контрагента не существует',
					type: 'error',
				});		
				return null;
			}

			ElNotification({
				message: 'Ошибка соединения, не удалось загрузить контрагента',
				type: 'error',
			});
			return null;
		}
	}

	async fetchOrdersAsync() {		
		try {
			this.isOrdersLoadPending = true;						
			const filterObject = {
				orderBy: this.ordersSortColumn,
				orderAsc: this.ordersSortDir == 'ascending',
				counterparty: this.originCounterparty!.id,
			};			
			const ordersHttpClient = axiosHelper.createInstance(store.getters.jwt);
			const ordersResponse = await ordersHttpClient.get('/api/orders', { params: filterObject });
			if (!ordersResponse.data?.length) {
				this.ordersList = [];
				return;
			}
			this.ordersList = ordersResponse.data.map((_: any) => new OrderModel(_));
		} catch (e: any) {			
			if (e.code == 'ERR_NETWORK') {
				ElNotification({
					message: 'Ошибка соединения, не удалось загрузить список заказ-нарядов',
					type: 'error',
				});
			} else {
				ElNotification({
					message: 'Ошибка загрузки списка заказ-нарядов',
					type: 'error',
				});
			}
			console.error('Error loading orders list', e);
		} finally {
			this.isOrdersLoadPending = false;
		}
	}

	mapCounterpartyRequest(requestForm: ICounterpartyForm) {
		const d = requestForm.birthdate ? new Date(requestForm.birthdate) : null;
		const birthdate = d ? dateFormatter.toUtcJson(d) : null;
		const types = requestForm.counterpartyTypes?.length ? requestForm.counterpartyTypes.map(_ => _) : null;

		return {
			id: requestForm.id,
			firstname: requestForm.firstname,
			lastname: requestForm.lastname,
			middlename: requestForm.middlename,
			isMale: requestForm.isMale,
			birthdate,
			phone: requestForm.phone,
			email: requestForm.email,						 
			notes: requestForm.notes,
			managerId: !requestForm.managerId ? null : requestForm.managerId,
			legalEntityId: requestForm.isLegal ? requestForm.legalEntity!.id : null,
			types
		};
	}

	dateFormatter(date: Date, showTime?: boolean, showYear?: boolean) {
		if (showYear === undefined) {
			showYear = false;
		}

		return dateFormatter.dateTime(date, showYear, true, showTime, ', ');
	}

	tableOrderTotalCostFormatter(order: OrderModel) {
		return (
			(order.customerItemsTotalCost ?? 0) +
			(order.customerJobsTotalCost ?? 0)
		).toLocaleString('ru').replace(',', '.');
	}

	calculateOrdersTotalCostSum(param: any) {		
		const { columns, data } = param;	
		const totalColumnIndex = columns
			.find((_: any) => _.columnKey == 'orderTotal').no;	

		if (!totalColumnIndex) {
			return;
		}		
		let total = 0;
		data.forEach((row: OrderModel) => total += (row.customerJobsTotalCost + row.customerItemsTotalCost));

		let totalRow = new Array<any>();

		for(let c = 0; c <= totalColumnIndex; c++) {
			if (c == totalColumnIndex) {
				const el = h('div', { style: { fontSize: '1.06rem' } }, [ total.toLocaleString('ru').replace(',', '.') ]);
				totalRow.push(el);
			} else {
				totalRow.push('');
			}
		}

		return totalRow;
	}

	legalEntityValidator(field: any, value: any, callback: any) {		
		if (!this.ruleForm.isLegal) {
			return true;
		}

		if (!this.ruleForm.legalEntity?.id) {
			callback(new Error('Юридическое лицо не указано'));
			return false;
		}

		return true;
	}	
}
</script>
